import { render, staticRenderFns } from "./OaEmployeeAttachments.vue?vue&type=template&id=86fa173c&"
import script from "./OaEmployeeAttachments.vue?vue&type=script&lang=js&"
export * from "./OaEmployeeAttachments.vue?vue&type=script&lang=js&"
import style0 from "./OaEmployeeAttachments.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports